import { Plus, Edit, CheckCircle, Trash2, FileText } from 'lucide-react';

/**
 * Format relative time ("2 minutes ago")
 * Converts a date string to a human-readable relative time in Italian
 */
export function formatRelativeTime(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (seconds < 60) return 'adesso';
  if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    return `${minutes} minut${minutes === 1 ? 'o' : 'i'} fa`;
  }
  if (seconds < 86400) {
    const hours = Math.floor(seconds / 3600);
    return `${hours} or${hours === 1 ? 'a' : 'e'} fa`;
  }
  if (seconds < 604800) {
    const days = Math.floor(seconds / 86400);
    return `${days} giorn${days === 1 ? 'o' : 'i'} fa`;
  }

  // More than a week ago, show date
  return date.toLocaleDateString('it-IT');
}

/**
 * Get human-readable action label in Italian
 */
export function getActionLabel(action: string): string {
  const labels: Record<string, string> = {
    'catalog.create': 'Catalogo creato',
    'catalog.update': 'Catalogo aggiornato',
    'catalog.publish': 'Catalogo pubblicato',
    'catalog.delete': 'Catalogo eliminato',
  };
  return labels[action] || action;
}

/**
 * Get action icon component
 */
export function getActionIcon(action: string) {
  const icons: Record<string, typeof Plus> = {
    'catalog.create': Plus,
    'catalog.update': Edit,
    'catalog.publish': CheckCircle,
    'catalog.delete': Trash2,
  };
  return icons[action] || FileText;
}

/**
 * Action color classes for badges
 */
export const actionColors: Record<string, string> = {
  'catalog.create': 'bg-green-100 text-green-700 border-green-300',
  'catalog.update': 'bg-blue-100 text-blue-700 border-blue-300',
  'catalog.publish': 'bg-purple-100 text-purple-700 border-purple-300',
  'catalog.delete': 'bg-red-100 text-red-700 border-red-300',
};

/**
 * Get action color class (fallback to gray)
 */
export function getActionColor(action: string): string {
  return actionColors[action] || 'bg-gray-100 text-gray-700 border-gray-300';
}
